import {Box} from '@mui/material';
import {DeviceTabs} from '../../../../../../components/device-tabs/device-tabs';
import {CaregiverMode} from '../../../../../../enums/caregiver-mode';

export default function DeviceSystemAdministratorOfficeScreen() {
  return (
    <Box
      sx={{
        background: '#FFFFFF',
        width: '100%',
        padding: {xs: '40px 10px 51px 10px', md: '40px 66px 51px 66px'},
        borderRadius: '10px',
      }}
    >
      <DeviceTabs caregiverMode={CaregiverMode.SystemAdministrator} />
    </Box>
  );
}
